import React from "react";
import { LogoHeader } from "../../Components/Inicio/LogoHeaderComponent";
import { NavDesktop } from "../../Components/Inicio/NavDesktop";
import { NavMobile } from "../../Components/Inicio/NavMobile";
import { PerfilComponent } from "../../Components/Usuarios/PerfilComponent";
import { Footer } from "../../Components/Footer/FooterComponent";

export const Perfil = (props) => {
    return (
        <>
            <LogoHeader I18n={props.I18n} />
            <NavDesktop I18n={props.I18n} />
            <NavMobile I18n={props.I18n} />
            <PerfilComponent I18n={props.I18n} user={props.User} />
            <Footer I18n={props.I18n} />
        </>
    );
}
